export const WEBAUTH_URL = {
	CLIENT_WEBAUTHN: '/web-authentication',
	CLIENT_VERIFY_PHONE: '/verify-phone',
};
